import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Carrot ("Carrot", "we", "us"). By accessing or
        using Carrot, you agree to these Terms. Carrot is currently provided as a Beta service.
      </p>

      <Section heading="Using Carrot">
        <p>
          You must sign in with a valid Google account to use Carrot. You are responsible for the activity
          that happens under your account and for keeping your Google account secure.
        </p>
      </Section>

      <Section heading="Your content">
        <p>
          You retain ownership of the tasks, notes, and other content you create in Carrot. You grant us the
          limited permission needed to store and display that content back to you and to any workspace members
          you choose to share it with.
        </p>
      </Section>

      <Section heading="Acceptable use">
        <ul className="list-disc pl-6 space-y-1">
          <li>Don't use Carrot for anything unlawful or abusive</li>
          <li>Don't attempt to disrupt, reverse engineer, or gain unauthorized access to the service</li>
          <li>Don't upload content that infringes others' rights</li>
        </ul>
      </Section>

      <Section heading="Beta service">
        <p>
          Carrot is in Beta. Features may change, break, or be removed, and data may occasionally be affected.
          During Beta, all users have access to premium ("Pro/Team") features free of charge; this may change
          when Carrot leaves Beta.
        </p>
      </Section>

      <Section heading="Availability & disclaimer">
        <p>
          Carrot is provided "as is" and "as available", without warranties of any kind. We do not guarantee
          that the service will be uninterrupted, error-free, or that data will never be lost.
        </p>
      </Section>

      <Section heading="Limitation of liability">
        <p>
          To the maximum extent permitted by law, Carrot will not be liable for any indirect, incidental, or
          consequential damages arising from your use of the service.
        </p>
      </Section>

      <Section heading="Termination">
        <p>
          You may stop using Carrot at any time and request deletion of your account. We may suspend or
          terminate accounts that violate these Terms.
        </p>
      </Section>

      <Section heading="Changes to these Terms">
        <p>
          We may update these Terms from time to time. Continued use of Carrot after changes means you accept
          the updated Terms. Material changes will be reflected by updating the "Last updated" date above.
        </p>
      </Section>
    </LegalLayout>
  );
}
